import React from 'react';
import styles from './HowToStart.module.css';

const SOCIALS = [
  { name: 'Discord', icon: '/discord.png', href: 'https://discord.gg/7CVSZpfYNp' },
  { name: 'Telegram', icon: '/telegram.png', href: 'https://t.me/hytale_interworld' }
];

const HowToStart = () => {
  const copyIp = () => {
    navigator.clipboard.writeText('play.interworld.fun');
    alert('IP скопирован: play.interworld.fun');
  };

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        {/* Колонка: Как начать играть */}
        <div className={styles.col}>
          <h2 className={styles.title}>Как начать играть?</h2>
          <p className={styles.subtitle}>Всего пара простых шагов — и ты в игре!</p>

          <div className={styles.steps}>
            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <img src="/logo-h.png" alt="Hytale" />
              </div>
              <div className={styles.stepContent}>
                <h3>Установи Hytale</h3>
                <p>Скачай и установи игру из официального источника</p>
              </div>
              <a
                href="https://hytale.com/"
                target="_blank"
                rel="noreferrer"
                className={`${styles.stepBtn} ${styles.stepBtnGhost}`}
              >
                <span className={styles.btnArrow}>↗</span>
                На сайт
              </a>
            </div>

            <div className={styles.step}>
              <div className={styles.stepIcon}>
                <img src="/minilogo.png" alt="InterWorld" />
              </div>
              <div className={styles.stepContent}>
                <h3>Подключайся к серверу</h3>
                <p>Скопируй IP и добавь в список серверов</p>
              </div>
              <button onClick={copyIp} className={styles.stepBtn}>
                <span className={styles.btnArrow}>⧉</span>
                Скопировать
              </button>
            </div>
          </div>

          <div className={styles.helpRow}>
            <span>Вопросы или проблемы?</span>
            <a href="/getting-started">
              <span className={styles.helpIcon}>▶</span>
              Посмотри руководство
            </a>
          </div>
        </div>

        {/* Колонка: Двигайся с нами */}
        <div className={styles.col}>
          <h2 className={styles.title}>Присоединяйся к нам</h2>
          <p className={styles.subtitle}>Узнавай первым об акциях и новостях</p>

          <div className={styles.socialsGrid}>
            {SOCIALS.map((s) => (
              <a
                key={s.name}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                className={styles.socialCard}
              >
                <img src={s.icon} alt={s.name} />
                <span>{s.name}</span>
              </a>
            ))}
          </div>

          <div className={styles.helpRow}>
            <span>Хочешь стать медиа‑партнёром?</span>
            <a href="/contacts">
              <span className={styles.helpIcon}>✉</span>
              Напиши нам!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToStart;
